import styles from '../components/**/*_component.css'
